const aboutContent = [
  {
    key: 1,
    title: "TED TALES",
    text: `TED is an international nonprofit organization devoted to spreading ideas, usually in the form of short, powerful talks (18 minutes or less). TED began in 1984 as a conference where Technology, Entertainment and Design converged, and today covers almost all topics — from science to business to global issues — in more than 100 languages. Meanwhile, independently run TEDx events help share ideas in communities around the world.

`,
  },
  {
    key: 2,
    title: "TEDx",
    text: `A TEDx event is a local gathering where live TED-like talks and performances are shared with the community. TEDx events are fully planned and coordinated independently under license granted by TED. Talks delivered at TEDx are live-streamed and recorded. The videos are edited and uploaded to the official TEDx YouTube channel with over 36 million subscribers. TEDx events are non religious and non political. It is a rich blend of Talks and performances to make the most engaging educative experience. TEDx events across the world have hosted figures such as Ngozi Iweala, Chinanmanda Adichie, Cobhams Asuquo, TY Bello.`,
    position: "right",
    img: "hide_img",
  },
  {
    key: 3,
    title: "TEDx AjayiCrowtherU",
    text: `TedxAjayiCrowtherU is an independently organized event where Ted-like talks are been shared with the aim of assisting students to achieve excellence, not just academically but in other aspect of life. We at TedxAjayiCrowther University will be hosting transformational coaches and creativity experts who will enlighten us more in the world of creativity and also how to imbibe creativity in very skill you possess. It doesn’t stop there. We at TedxAjayiCrowtherU will be looking into the following aspect on the 6th May 2023: Business and Brand Strategy, Writing and Publishing, Brand Storytelling, Entrepreneurship, Leadership.`,
    img: "hide_img",
  },
];

const home_details = aboutContent[0];

export default aboutContent;
export { home_details };
